import React, { useMemo } from 'react';
import { useAITTheme } from '@this/shared/ui/theme';

interface Props {
  title: string;
  icon?: React.ReactNode;
  children: React.ReactNode;
}

const CancelPolicySection: React.FC<Props> = ({ title, icon, children }) => {
  const { theme } = useAITTheme();
  const styles = useMemo(() => getStyles(theme.tokens.colors), [theme.tokens.colors]);

  return (
    <section>
      <h2 style={styles.header}>
        {icon}
        {title}
      </h2>
      <div style={styles.body}>{children}</div>
    </section>
  );
};

const getStyles = (colors: { common: { white: string } }) => ({
  header: {
    display: 'flex' as const,
    alignItems: 'center' as const,
    gap: 8,
    margin: 0,
    padding: '10px 16px',
    background: '#292929',
    color: colors.common.white,
    fontSize: 14,
    fontWeight: 'bold' as const,
    lineHeight: 1.4
  },
  body: {
    padding: 16,
    background: colors.common.white
  }
});

export default CancelPolicySection;
